export default __webpack_public_path__ + "static/media/k12.4096184a.jpg";